import { Injectable, inject } from '@angular/core';
import { ActiveRoleService } from '../active-role.service';
import { UserRole } from '../user-role.types';

export interface MockCaseAccessContext {
  role: UserRole;
  userId?: string;
  agentId?: string;
  portfolioIds: readonly string[];
  creditorIds: readonly string[];
}

/** Central mock-only access boundary for collection cases. */
@Injectable({ providedIn: 'root' })
export class MockAccessScopeService {
  private readonly activeRole = inject(ActiveRoleService, { optional: true });

  get context(): MockCaseAccessContext {
    const role = this.activeRole?.currentRole() ?? 'ADMIN';
    const user = this.activeRole?.currentUser();
    return {
      role,
      userId: user?.userId,
      agentId: user?.agentId,
      portfolioIds: user?.portfolioIds ?? [],
      creditorIds: user?.creditorIds ?? [],
    };
  }

  canAccessCase(caseItem: { agentId?: string; portfolioId?: string; creditorId?: string }): boolean {
    if (!this.activeRole) return true;
    const context = this.context;
    if (context.role === 'AGENT') {
      return !!context.agentId && caseItem.agentId === context.agentId;
    }
    const portfolioAllowed = context.portfolioIds.length === 0 ||
      (!!caseItem.portfolioId && context.portfolioIds.includes(caseItem.portfolioId));
    const creditorAllowed = context.creditorIds.length === 0 ||
      (!!caseItem.creditorId && context.creditorIds.includes(caseItem.creditorId));
    return portfolioAllowed && creditorAllowed;
  }

  filterAuthorizedCases<T extends { agentId?: string; portfolioId?: string; creditorId?: string }>(cases: readonly T[]): T[] {
    return cases.filter(item => this.canAccessCase(item));
  }
}
